import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class CoachService {
  public navigateToNotifications = new BehaviorSubject<any>(false);
  public profileUpdated = new BehaviorSubject<any>(false);
  public showleftMenue = new BehaviorSubject<any>(false);
  public  getSportLevel = new BehaviorSubject<any>(
    localStorage.getItem('get_sport_level')
      ? JSON.parse(localStorage.getItem('get_sport_level')!)
      : null
  );
  public  getSportID = new BehaviorSubject<any>(
    localStorage.getItem('sport_level')
      ? JSON.parse(localStorage.getItem('sport_level')!)
      : null
  );
  public  getCoachDetail = new BehaviorSubject<any>(
    localStorage.getItem('selected_coach')
      ? JSON.parse(localStorage.getItem('selected_coach')!)
      : null
  );
  sportLevel$ = this.getSportLevel.asObservable();
  sportID$ = this.getSportID.asObservable();
  coachDetail$ = this.getCoachDetail.asObservable();

  constructor(private httpService: HttpService) { }

  SetSportLevel(sport_level:any=null) {
  if(sport_level)
  {
  localStorage.setItem('sport_level',JSON.stringify(sport_level));
  }
  this.getSportID.next(sport_level);

  }
  SetSportLevelName(sport_level:any=null) {
  if(sport_level)
  {
      localStorage.setItem('get_sport_level',JSON.stringify(sport_level));

  }
  this.getSportLevel.next(sport_level);
  }
  setCoach(coach:any)
  {
    localStorage.setItem('selected_coach',JSON.stringify(coach));
    this.getCoachDetail.next(coach);

  }
  getCoach()
  {
    return localStorage.getItem('selected_coach') ?? null;
  }
  fetchSettings() {
    return this.httpService.post('settings', {});
  }

  fetchAllMaster(payload: any = {}) {
    return this.httpService.post('common/list', payload);
  }

  fetchLevelsMaster(payload: any = {}) {
    return this.httpService.post('level/list', payload);
  }

  getMasterSchoolDetails(payload: any) {
    return this.httpService.post('school/details', payload);
  }
  pruchaseSubscription(payload: any) {
    //return this.httpService.post('subscription/plan/purchase', payload);
    return this.httpService.post('subscription/plan/purchase', payload);

  }
  allsubscriptionPlans(payload: any) {
    return this.httpService.post('subscription/plan/list', payload);
  }

  /**
   * ==============================
   * SCHEDULES METHODS ------------
   * ==============================
   */

  fetchSchedules(payload: any) {
    return this.httpService.post('coach/schedule/list', payload);
  }
  fetchCoachList(payload: any) {
    return this.httpService.post('coach/school-coach-list', payload);
  }

  scheduleSubmit(payload: any) {
    if (payload._id) {
      return this.httpService.post('coach/schedule/update', payload);
    } else {
      return this.httpService.post('coach/schedule/add', payload);
    }
  }

  changeScheduleStatus(payload: any) {
    return this.httpService.post('coach/schedule/status-change', payload);
  }
  fetchCalenderApprovedSchedules(payload: any) {
    return this.httpService.post(
      'coach/schedule/calender_schedule_list',
      payload
    );
  }
  /**
   * ================================
   * TOURNAMENTS METHODS ------------
   * ================================
   */

  fetchTournaments(payload: any) {
    return this.httpService.post('coach/tournament/list', payload);
  }

  tournamentSubmit(payload: any) {
    if (payload._id) {
      return this.httpService.post('coach/tournament/update', payload);
    } else {
      return this.httpService.post('coach/tournament/add', payload);
    }
  }
  tournamentJoinSubmit(payload: any) {
    if (payload._id) {
      return this.httpService.post(
        'coach/tournament/update_join_status',
        payload
      );
    } else {
      return this.httpService.post('coach/tournament/join', payload);
    }
  }

  fetchSentTournamentsList(payload: any) {
    return this.httpService.post('coach/tournament/sent_request_list', payload);
  }
  fetchReceiveTournamentsList(payload: any) {
    return this.httpService.post(
      'coach/tournament/receive-request-list',
      payload
    );
  }

  fetchParticipants(payload: any) {
    return this.httpService.post('coach/tournament/get_participants', payload);
  }

  changeTournamentStatus(payload: any) {
    return this.httpService.post('coach/tournament/status-change', payload);
  }
  availableCoachForTournaments(payload: any) {
    return this.httpService.post('coach/tournament/find-coach', payload);
  }
  sendTournamentJoinRequestToCoach(payload: any) {
    return this.httpService.post('coach/tournament/join-by-coach', payload);
  }
  upcomingTournaments(payload: any) {
    return this.httpService.post(
      'coach/tournament/upcoming_tournaments',
      payload
    );
  }
  fetchApprovedParticipants(payload: any) {
    return this.httpService.post(
      'coach/tournament/get_approve_participants',
      payload
    );
  }
  fetchCalenderApprovedTournaments(payload: any) {
    return this.httpService.post(
      'coach/tournament/calender_tournament_list',
      payload
    );
  }

  /**
   * ================================
   * COACH DETAILS ------------
   * ================================
   */
  coachDetails(payload: any) {
    return this.httpService.post('coach/details', payload);
  }
  coachRequests(payload: any) {
    return this.httpService.post('coach/sports-request-list', payload);
  }
  sentSportsRequest(payload: any) {
    return this.httpService.post('coach/sports-request', payload);
  }
  removeCoach(payload: any) {
    return this.httpService.post('coach/coach-status-change', payload);
  }
  updateCoachDetails(payload: any) {
    return this.httpService.post('coach/update', payload);
  }
  updateProfilePicture(payload: any) {
    return this.httpService.postFormData(
      'coach/update-profile-picture',
      payload
    );
  }
  /**
   * ================================
   * GAME METHODS ------------
   * ================================
   */
  fetchGames(payload: any) {
    return this.httpService.post('coach/game/list', payload);
  }

  gameRequestSubmit(payload: any) {
    if (payload._id) {
      return this.httpService.post('coach/game/update', payload);
    } else {
      return this.httpService.post('coach/game/add', payload);
    }
  }
  /**
   * ================================
   * NOTIFICATION METHODS ------------
   * ================================
   */
  fetchNotifications(payload: any) {
    return this.httpService.post('subscription/notification/list', payload);
  }
  deleteNotification(payload: any) {
    return this.httpService.post('coach/notification/delete', payload);
  }
  countNotification(payload: any) {
    return this.httpService.post('coach/notification/count_unread', payload);
  }
  /**
   * ================================
   * TUTORIALS METHODS ------------
   * ================================
   */
  fetchTutorials(payload: any) {
    return this.httpService.post('coach/tutorials/list', payload);
  }
  /**
   * ================================
   * DASHBOARD COUNTS ------------
   * ================================
   */
  dashboardCounts(payload: any) {
    return this.httpService.post('coach/dashboard-count', payload);
  }
  /**
   * ================================
   * CMS PAGES API ------------------
   * ================================
   */
  fetchHomePage(payload: any) {
    return this.httpService.post('dashboard', payload);
  }
  fetchHowItWorks(payload: any) {
    return this.httpService.post('how-it-works', payload);
  }
  fetchAboutUs(payload: any) {
    return this.httpService.post('about', payload);
  }
  fetchPrivacyPolicy(payload: any) {
    return this.httpService.post('privacy-policy', payload);
  }
  fetchTermsAndCondition(payload: any) {
    return this.httpService.post('terms-and-condition', payload);
  }
  addSubscribe(payload: any) {
    return this.httpService.post('subscribe', payload);
  }
  addContactUs(payload: any) {
    return this.httpService.post('contact-us', payload);
  }
  /**
   * ================================
   * -------------CANCEL ------------
   * ================================
   */
  cancelScheduleGame(payload: any) {
    return this.httpService.post('coach/game/cancel-game', payload);
  }
  cancelTournament(payload: any) {
    return this.httpService.post('coach/tournament/cancel-tournament', payload);
  }
  /**
   * ================================
   * ----TOURNAMENT AVAILABILITY-----
   * ================================
   */
  tournamentAvailabilitySubmit(payload: any) {
    if (payload._id) {
      return this.httpService.post('coach/tournament-schedule/update', payload);
    } else {
      return this.httpService.post('coach/tournament-schedule/add', payload);
    }
  }
  fetchTournamentAvailability(payload: any) {
    return this.httpService.post('coach/tournament-schedule/list', payload);
  }
  changeTournamentAvailabilityStatus(payload: any) {
    return this.httpService.post(
      'coach/tournament-schedule/status-change',
      payload
    );
  }

  /**
   * ================================
   * -------------CALENDER-----------
   * ================================
   */
  fetchCalenderTournamentScheduleList(payload: any) {
    return this.httpService.post(
      'coach/tournament-schedule/calender_schedule_list',
      payload
    );
  }
  /**
   * ====================================
   * -------------SUBSCRIPTION-----------
   * ====================================
   */
  fetchSubscriptionPlanList(payload: any) {
    return this.httpService.post('plan', payload);
  }
  applyCoupan(payload: any) {
    return this.httpService.post('subscription/plan/apply-coupon', payload);
  }
  /**
   * ====================================
   * -------------TRANSACTIONS-----------
   * ====================================
   */
  fetchTransactions(payload: any) {
    return this.httpService.post('subscription/plan/transaction-list', payload);
  }

  /**
   * ====================================
   * --------CANCEL OWN TOURNAMENT-------
   * ====================================
   */
  cancelOwnTournament(payload: any) {
    return this.httpService.post(
      'coach/tournament/cancel-main-tournament',
      payload
    );
  }
  applySchoolCouponCode(payload: any) {
    return this.httpService.post('subscription/apply-school-coupon', payload);
  }
  coachActivePlanDetails(payload: any) {
    return this.httpService.post('coach/active-plan', payload);
  }
  templateDetails(payload: any) {
    return this.httpService.post('coach/template/details', payload);
  }
  templateSave(payload: any) {
    return this.httpService.post('coach/template/save', payload);
  }
  sendEmail(payload: any) {
    return this.httpService.post('coach/send-email', payload);
  }

  /**
    * ====================================
    * --------Payment Subscription-------
    * ====================================
    */
  purchaseSubscription(payload: any) {
    return this.httpService.post('subscription/purchase-subscription', payload);
  }

  /**
     * ====================================
     * --------Set Venue-------
     * ====================================
     */
  setVenue(payload: any) {
    return this.httpService.post('coach/game/update-game-venue', payload);
  }
  getSelectedSportlevel()
  {
    const sport_level=localStorage.getItem('sport_level')
    return (sport_level?sport_level:null);
  }



}
